import i18next from 'i18next';
import React, { useEffect, useRef, useState } from 'react';

import { Icon } from '../../../base/icons';
import { IconArrowDown, IconArrowUp } from '../../../base/icons/svg';
import LIBRE_SUPPORTED_LANGS from '../../../transcribing/libre-supported-langs.json';

interface ILanguageItem {
  id: string;
  lang: string;
  selected: boolean;
}

interface ILanguageListProps {
  items: Array<ILanguageItem>;
  onLanguageSelected: (lang: string) => void;
  selectedLanguage: string;
  t: (key: string) => string;
  switchEnabled: boolean;
  language: stringSimilarity;
}

/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
const LanguageList = ({
    onLanguageSelected,
    t,
    switchEnabled,
    language,
    translationEnabled
}: ILanguageListProps) => {
    const { language: currentLanguage } = i18next;

    const [ isOpen, setIsOpen ] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = event => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onLanguageSelectedWrapper = item => {
        onLanguageSelected(item);
        setIsOpen(false);
    };

    const toggleDropdown = () => {
        setIsOpen(prev => !prev);
    };

    const currentLangData = LIBRE_SUPPORTED_LANGS.find(lang => lang.code === currentLanguage);

    const targetLanguages = currentLangData ? currentLangData.targets : [];

    const translationListItems = targetLanguages.length > 0
        ? targetLanguages.map(item => (
            <li
                className = 'language-list__dropdown-list-item'
                key = { item }
                onClick = { () => onLanguageSelectedWrapper(item) }>
                { t(`languages:${item}`) }
            </li>
        )) : (<li className = 'language-list__dropdown-list-item language-list__dropdown-list-item--disabled'>
            { t('languages:not_available') }
        </li>);

    return (
        <div className = 'language-list__items-container'>
            <div
                className = 'dropdown-menu1'>
                {
                    switchEnabled && translationEnabled === true && (
                        <div
                            className = 'language-list__dropdown-container'>
                            <span className = 'language-list__label'>{ t('transcribing.TranslateTo') }</span>
                            { translationListItems.length > 0
                                ? <div
                                    className = 'dropdown-min-width language-list__dropdown-wrapper'
                                    ref = { wrapperRef }>
                                    <button
                                        className = 'language-list__dropdown-trigger'
                                        onClick = { toggleDropdown }
                                        type = 'button'>
                                        { typeof language === 'string' ? t(`languages:${language.split('-')[0]}`) : t('transcribing.TranslateTo') }
                                        <Icon src = { isOpen ? IconArrowUp : IconArrowDown } />
                                    </button>
                                    { isOpen && (
                                        <ul
                                            className = 'dropdown-menu-languages language-list__dropdown-list'>
                                            { translationListItems }
                                        </ul>
                                    ) }
                                </div> : <span className = 'language-list__font16'>{ t('transcribing.TranslationNotAvailable') }</span> }
                        </div>
                    )
                }
            </div>
        </div>
    );
};


export default LanguageList;
